import { createContext, useContext } from 'react'

export const QuickLogContext = createContext<{ open: () => void }>({ open: () => {} })

export function useQuickLog() {
  return useContext(QuickLogContext)
}
